
<template>
  <!--新增官方消息-->
  <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="submitForm"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      :width=900
    >
  <x-addEdit
    ref="addEdit"
    :initReqHandle="false"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="pageLayout"
    :isSubmitBtn="false"
  >
    <template slot="publishTime" slot-scope="{formItem}">
      <a-form-item class="publish-time" :label="formItem.label" :required="formItem.props[1].rules[0].required" v-bind="pageLayout" ref='sendTime'>
        <a-row type="flex">
          <a-col>
            <a-form-item>
              <a-radio-group v-if="!isEdit" @change="publishChange" v-decorator="formItem.props" :disabled="formItem.radioDisabled">
                <a-radio :value="1">立即发送</a-radio>
                <a-radio :value="2">定时发送</a-radio>
              </a-radio-group>

              <span v-else class="ant-form-text">{{textData}}</span>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item>
              <a-date-picker v-if="!isEdit" v-decorator="formItem.dateProps" :disabled="formItem.pickerDisabled" showTime format="YYYY-MM-DD HH:mm:ss"/>

              <span v-else class="ant-form-text"> {{textTime}}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
    </template>

    <template slot="msgContent" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="pageLayout">
        <wangedit ref='wangedit'></wangedit>
      </a-form-item>
    </template>
  </x-addEdit>
  </a-modal>
</template>

<script>
import { fetchSelect, userRange } from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import Moment from 'moment';
import wangedit from '@/components/package/wangedit.vue';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'addOfficialMsg',
  components: {
    wangedit
  },
  data () {
    return {
      isEdit: false,
      pageLayout: {
        labelCol: {span: 3},
        wrapperCol: {span: 19}
      },
      modalTitle: '新增',
      visible: false,
      textData: undefined,
      textTime: undefined,
      editorVal: undefined,
      isLoding: false,
      formKey: {
        title: '',
        content: '',
        precis: '',
        userType: undefined,
        sendType: undefined
      },
      formList: [
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['title', {
            validateTrigger: 'blur',
            rules: [
              { required: true, message: '请输入标题' },
              { min: 1, max: 30, message: '标题为1-30个字' },
              {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}
            ]
          }]
        }, {
          slot: 'msgContent',
          label: '正文',
          inputType: 'input',
          options: [],
          placeholder: '请输入消息内容',
          props: ['content', {
            validateTrigger: 'blur',
            rules: [{ required: true, message: '请输入内容' }]
          }]
        },
        {
          label: '摘要',
          inputType: 'input',
          options: [],
          placeholder: '请输入摘要',
          props: ['precis', {
            validateTrigger: 'blur',
            rules: [{ required: true, message: '请输入摘要' },
              { min: 1, max: 50, message: '摘要为1-50个字' }
            ]
          }]
        },
        {
          label: '用户类型',
          inputType: 'select',
          options: [

          ],
          placeholder: '请选择用户类型',
          handle: e => this.handleUserRange(e),
          props: ['userType', {
            rules: [{required: true, message: '请选择用户类型'}]
          }]
        },

        {
          slot: 'publishTime',
          label: '发布时间',
          inputType: 'radioGroup',
          options: [],
          radioDisabled: false,
          pickerDisabled: true,
          props: ['sendType',
            {initialValue: 1, rules: [{required: true, message: '请选择发布时间'}]}
          ],
          dateProps: ['sendTime', {
            rules: [{required: false, message: '请选择定时发布时间'}]
          }]
        }
      ],
      addParam: {
        url: '/housekeep/message/add',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/housekeep/message/',
        pathParam: true,
        resHandle: this.editResHandle
      },
      detailParam: {
        url: '/messageList/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    show (row) {
      this.isEdit = true;
      this.modalTitle = '编辑';
      let id = row && row.messageId;
      this.visible = true;
      let url = `${this.editParam.url}${id}`;
      this.formList[0].inputType = 'text';
      this.formList[2].inputType = 'text';
      this.formList[3].inputType = 'text';
      this.formList[4].props[1].rules[0].required = false;

      this.$nextTick(() => {
        this.$refs.addEdit.routeQuery = id;
        this.$refs.addEdit.getDetail(url);
      });
    },
    submitForm () {
      if (this.isLoding == true) {
        return;
      }

      this.$refs.addEdit.handleSubmit();
      this.isLoding = true;
      setTimeout(() => {
        this.isLoding = false;
      }, 1000);
    },
    closeFun () {
      this.visible = false;
      this.formList[0].inputType = 'input';
      this.formList[2].inputType = 'input';
      this.formList[3].inputType = 'select';
      this.formList[4].props[1].rules[0].required = true;
      this.formList[4].dateProps[1].rules[0].required = false;
      this.formList[4].pickerDisabled = true;
      this.isEdit = false;
      this.modalTitle = '新增';
    },
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/housekeep_message_user_type',
        params: {}
      }).then(({data}) => {
        this.formList[3].options = data;
      });
    },
    /* 处理用户范围 */
    handleUserRange (val, formValues) {

    },
    /* 发布时间 change */
    publishChange (e) {
      this.handleDealyTime(e.target.value);
    },
    /* 处理定时发送单选框 */
    handleDealyTime (value) {
      let index;
      this.formList.forEach((el, i) => {
        let props = el.props;
        if (props && props[0] === 'sendType') {
          index = i;
        }
      });
      let sendTime = this.formList[index].dateProps[1].rules[0];
      let list = this.formList[index];
      value === 2 ? sendTime.required = true : sendTime.required = false;
      value === 2 ? list.pickerDisabled = false : list.pickerDisabled = true;
      this.$refs.addEdit.$children[0].form.resetFields(['sendTime']);
    },
    addResHandle (res) {
      this.closeFun();
      this.$emit('updateList');
      return res;
    },
    reqHandle (param) {
      // param.sendTime && (param.sendTime = param.sendTime.format('YYYY-MM-DD HH:mm:ss'));
      if (!this.isEdit && (new Date(param.sendTime).getTime() < new Date().getTime())) {
        this.$message.error('发布时间不能小于当前时间');
        return;
      }
      this.editorVal = this.$refs.wangedit.html;

      let pureText = this.editorVal.replace(/&nbsp;/g, '').replace(/\s+/g, '').replace(/<p><br><\/p>/g, '').replace(/<p><\/p>/g, '');
      if (pureText == '') {
        this.$message.error('请输入正文内容');
        return;
      } else {
        param = {...param, ...{content: this.editorVal}};
      }

      return param;
    },
    detailResHandle (res) {
      let values = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = res[item];
        }
      }
      values.sendTime = Moment(res.sendTimeDesc, 'YYYY-MM-DD HH:mm:ss');

      res.scope && (values = this.rangeResVal(values, res));
      if (res.content && res.content !== '<p><br></p>') {
        this.$refs.wangedit.html = res.content;
      }
      this.formList[3].options.forEach(item => {
        if (item.value == values.userType) {
          values.userType = item.label;
        }
      });

      let delayObj = { 1: '立即发送', 2: '定时发送' };
      this.textData = delayObj[res.sendType];
      this.textTime = res.sendTime;
      values.sendTime = res.sendTime;

      return values;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      this.closeFun();
      return res;
    }
  }
};
</script>
